import { render, staticRenderFns } from "./ObjectStoreSelect.vue?vue&type=template&id=be298dde&scoped=true"
import script from "./ObjectStoreSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreSelect.vue?vue&type=style&index=0&id=be298dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be298dde",
  null
  
)

export default component.exports